@if (showModal()) {
  <div class="cookies-agreement">
    <p class="text-b3-s-300 text-lg-b3-m-300">
      мы используем файлы cookie, оставаясь на&nbsp;сайте вы соглашаетесь на их использование
      <a sdLink target="_blank" href="https://policy.sdvor.com/privacy#cookie-policy">подробнее</a>
    </p>
    <button sdButton theme="primary" (click)="onChangeAgreement()">хорошо</button>
  </div>
}
